import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { saveBank } from '../redux/userSlice';

const Bank = () => {

    // add -> adding bank, 
    // check -> getting list,
    const [status, setStatus] = useState("check");
    const [banks, setBanks] = useState([]);

    const dispatch = useDispatch();
    const selectedBank = useSelector(state => state.user.bank);
    console.log({ selectedBank });

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData.entries());

            const response = await axios.post("/bank/create", data);
            if (response.data.success) {
                toast.success(response.data.message);
                setStatus("check");
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    const getBankList = async () => {
        try {
            const response = await axios.get("/bank/");
            if (response.data.success) {
                setBanks(response.data.banks);
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    const handleSaveBank = (bankObject) => {
        dispatch(saveBank(bankObject))
    }

    const deleteBank = async (bankId) => {
        if (!window.confirm("Are you sure you want to delete?")) {
            return;
        }
        
        try {
            const response = await axios.delete(`/bank/${bankId}`);
            if (response.data.success) {
                toast.success(response.data.message);
                getBankList();
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    useEffect(() => {

        if (status === "check") {
            getBankList();
        }

    }, [status])

    return (
        <>
            <div className='p-5 flex gap-4 justify-center'>
                <button onClick={() => setStatus("add")} className='btn btn-primary text-white'>Add Bank Details</button>
                <button onClick={() => setStatus("check")} className='btn btn-primary text-white'>Bank List</button>
            </div>

            <div>
                {
                    status === "add"
                    &&
                    <>
                        <div className='flex justify-center'>
                            <form onSubmit={handleSubmit} class="space-y-4 w-[50vw] border-2 border-blue-700 p-4 rounded-lg shadow-md">
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
                                    <input
                                        type="text"
                                        name='bankName'
                                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
                                        placeholder="Bank Name" required
                                    />
                                </div>

                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
                                    <input
                                        type="text"
                                        name='accountNumber'
                                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
                                        placeholder="A/C No" required
                                    />
                                </div>

                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Branch Name</label>
                                    <input
                                        type="text"
                                        name='branch'
                                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
                                        placeholder="Branch Name" required
                                    />
                                </div>

                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">IFSC Code</label>
                                    <input
                                        type="text"
                                        name='IFSC'
                                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
                                        placeholder="IFSC Code" required
                                    />
                                </div>

                                <button class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 rounded-lg transition-colors">
                                    SAVE
                                </button>
                            </form>

                        </div>
                    </>
                }

                {
                    status === "check"
                    &&
                    <>
                        <div>
                            <div className="overflow-x-auto m-10">
                                <table className="table">
                                    {/* head */}
                                    <thead className='bg-blue-700 text-white font-bold'>
                                        <tr>
                                            <th></th>
                                            <th>Bank Name</th>
                                            <th>Account Number</th>
                                            <th>Branch</th>
                                            <th>IFSC</th>
                                            <th>Action</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            banks?.map((b, index) => {
                                                return (
                                                    <>
                                                        <tr className={`hover:cursor-pointer hover:bg-blue-100 ${b?._id === selectedBank?._id && "bg-blue-300"}`}>
                                                            <td>{index + 1}</td>
                                                            <td>{b?.bankName}</td>
                                                            <td>{b?.accountNumber}</td>
                                                            <td>{b?.branch}</td>
                                                            <td>{b?.IFSC}</td>
                                                            <td><button onClick={() => handleSaveBank(b)} className={`btn text-white ${b?._id === selectedBank?._id ? "btn-success" : "btn-primary"}`}>{b?._id === selectedBank._id ? "IN USE" : "USE"}</button></td>
                                                            <td><button onClick={() => deleteBank(b?._id)} type='button' className={`btn btn-error text-white hover:scale-110`}><i className="fa-solid fa-trash-can"></i></button></td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                }
            </div >
        </>
    )
}

export default Bank;